import { render, staticRenderFns } from "./case-study.vue?vue&type=template&id=786d2aea&scoped=true"
import script from "./case-study.vue?vue&type=script&lang=js"
export * from "./case-study.vue?vue&type=script&lang=js"
import style0 from "./case-study.vue?vue&type=style&index=0&id=786d2aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d2aea",
  null
  
)

export default component.exports